import { render, staticRenderFns } from "./Viewer3DSpecial.vue?vue&type=template&id=6b537b5a&scoped=true&"
import script from "./Viewer3DSpecial.vue?vue&type=script&lang=js&"
export * from "./Viewer3DSpecial.vue?vue&type=script&lang=js&"
import style0 from "./Viewer3DSpecial.vue?vue&type=style&index=0&id=6b537b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b537b5a",
  null
  
)

export default component.exports